import { render, staticRenderFns } from "./guanfang.vue?vue&type=template&id=d81844e6&scoped=true&"
import script from "./guanfang.vue?vue&type=script&lang=js&"
export * from "./guanfang.vue?vue&type=script&lang=js&"
import style0 from "./guanfang.vue?vue&type=style&index=0&id=d81844e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81844e6",
  null
  
)

export default component.exports